import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTopOnMount from "./components/ScrollToTopOnMount.jsx";
import Layout from "./components/Layout.jsx";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Service from "./pages/Services.jsx";
import Blog from "./pages/Blog.jsx";
import Contact from "./pages/Contact.jsx";
import Properties from "./pages/Properties.jsx";
import Faq from "./pages/Faq.jsx";
import Offer from "./pages/Offers.jsx";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BlogDetails from "./pages/BlogDetails.jsx";
import OfferDetails from "./pages/OfferDetails.jsx";
import PropertyDetails from "./pages/PropertyDetails.jsx";
import Purchase from "./pages/Purchase.jsx";
import Estates from "./pages/Estates.jsx";
import EstateDetails from "./pages/EstateDetails.jsx";
import EstateHouses from "./pages/EstateHouses.jsx";
import Plots from "./pages/Plots.jsx";
import PlotDetails from "./pages/PlotDetails.jsx";
import Layouts from "./pages/Layouts.jsx";
import LayoutDetails from "./pages/LayoutDetails.jsx";
import LayoutPlots from "./pages/LayoutPlots.jsx";
import Careers from "./pages/Careers.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsOfUse from "./pages/TermsOfUse.jsx";
import RoyalDynastyEstate from "./pages/RoyalDynastyEstate.jsx";
import EmperorVillaEstate from "./pages/EmperorVillaEstate.jsx";
import Diaspora from "./pages/Diaspora.jsx";
import TopEstates from "./pages/TopEstates.jsx";

function App() {
  return (
    <Router>
      <ScrollToTopOnMount />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/about"
          element={
            <Layout>
              <About />
            </Layout>
          }
        />

        <Route
  path="/top-estates"
  element={
    <Layout>
      <TopEstates />
    </Layout>
  }
/>

        <Route
  path="/diaspora-guide"
  element={
    <Layout>
      <Diaspora />
    </Layout>
  }
/>

        <Route
  path="/privacy-policy"
  element={
    <Layout>
      <PrivacyPolicy />
    </Layout>
  }
/>
<Route
  path="/terms-of-use"
  element={
    <Layout>
      <TermsOfUse />
    </Layout>
  }
/>
        <Route
          path="/services"
          element={
            <Layout>
              <Service />
            </Layout>
          }
        />
        <Route
          path="/blog"
          element={
            <Layout>
              <Blog />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />
        <Route
          path="/properties"
          element={
            <Layout>
              <Properties />
            </Layout>
          }
        />
        <Route
          path="/faq"
          element={
            <Layout>
              <Faq />
            </Layout>
          }
        />
        <Route
          path="/offers"
          element={
            <Layout>
              <Offer />
            </Layout>
          }
        />
        <Route
          path="/blogdetails"
          element={
            <Layout>
              <BlogDetails />
            </Layout>
          }
        />
        <Route
          path="/blogdetails/:postId"
          element={
            <Layout>
              <BlogDetails />
            </Layout>
          }
        />
        <Route
          path="/offers/:id"
          element={
            <Layout>
              <OfferDetails />
            </Layout>
          }
        />
        <Route
          path="/properties/:id"
          element={
            <Layout>
              <PropertyDetails />
            </Layout>
          }
        />
        <Route
          path="/purchase"
          element={
            <Layout>
              <Purchase />
            </Layout>
          }
        />
        <Route
          path="/purchase/:id"
          element={
            <Layout>
              <Purchase />
            </Layout>
          }
        />
        <Route
          path="/estates"
          element={
            <Layout>
              <Estates />
            </Layout>
          }
        />
        <Route
          path="/layouts"
          element={
            <Layout>
              <Layouts />
            </Layout>
          }
        />
        <Route
          path="/layouts/:id"
          element={
            <Layout>
              <LayoutDetails />
            </Layout>
          }
        />
        <Route
          path="/layouts/:id/plots"
          element={
            <Layout>
              <LayoutPlots />
            </Layout>
          }
        />
        <Route
          path="/estates/:id"
          element={
            <Layout>
              <EstateDetails />
            </Layout>
          }
        />
        <Route
          path="/estates/:id/houses"
          element={
            <Layout>
              <EstateHouses />
            </Layout>
          }
        />
        <Route
          path="/plots"
          element={
            <Layout>
              <Plots />
            </Layout>
          }
        />
        <Route
          path="/plots/:id"
          element={
            <Layout>
              <PlotDetails />
            </Layout>
          }
        />
        <Route
          path="/careers"
          element={
            <Layout>
              <Careers />
            </Layout>
          }
        />
        <Route
  path="/estates/royal-dynasty"
  element={
    <Layout>
      <RoyalDynastyEstate />
    </Layout>
  }
/>
<Route
  path="/estates/emperor-villa"
  element={
    <Layout>
      <EmperorVillaEstate />
    </Layout>
  }
/>
      </Routes>



    </Router>
  );
}

export default App;
